<template>
	<WebViewLayout class="bg-color-greige">
		<AnnualReturnsSection
			:show-single-year-returns="false"
			:is-webview="true"
			header-text="Invest without compromise."
		/>
		<CtaSection :is-webview="true" />
		<div v-if="isAndroidDevice" class="footer container py-200">
			<p
				v-for="(disclaimer, id) in disclaimerTextForAnnualReturns"
				:key="id"
				class="body-xs muted"
				v-html="disclaimer"
			>
			</p>
		</div>
	</WebViewLayout>
</template>

<script setup lang="ts">
import { annualReturnsDisclosureModalProps } from '@constants/annual-returns-data';
import AnnualReturnsSection from '@components/marketing-site/annual-returns-section.vue';
import { computed } from 'vue';
import CtaSection from '@components/marketing-site/cta-section.vue';
import { isAndroidDevice as isAndroid } from '@utils/client';
import WebViewLayout from '@views/webview/web-view-layout.vue';

const disclaimerTextForAnnualReturns = annualReturnsDisclosureModalProps.content;

const isAndroidDevice = computed((): boolean => {
	return isAndroid();
});
</script>
